<template>
  <router-link tag="div" :to="{ name: 'Experts details', params: { user: user.id } }" class="expert-block block">
    <div class="head">
      <Avatar :src="user.avatar" :online="user.online" />
      <div>
        <div class="name">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</div>
        <div class="user-role" v-text="user.role.title" />
      </div>
    </div>
    <div class="about">
      {{ user.description }}
    </div>
  </router-link>
</template>

<script>
import Avatar from '@/components/user/Avatar'
export default {
  name: 'Expert',
  components: { Avatar },
  props: {
    user: Object,
  },
  computed: {
    course() {
      return this.user?.course_type
    },
  },
}
</script>

<style lang="scss">
.expert-block {
  position: relative;
  padding: 20px 38px 29px 30px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 12px 21px rgba(180, 187, 198, 0.19);

  @include mobile {
    padding: 30px 30px 16px;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0;
    background: $primary;
    opacity: 0;
    transition: all 0.25s;
  }

  &:hover::before {
    height: 3px;
    opacity: 1;
  }

  .badge {
    position: absolute;
    top: 19px;
    right: 37px;
    text-transform: capitalize;
  }

  .head {
    display: flex;
    align-items: center;
    margin-bottom: 27px;

    @include mobile {
      margin-bottom: 18px;
    }
  }

  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 10px;
    margin-right: 23px;
  }

  .name {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }

  .about {
    font-weight: 400;
    font-size: 15px;
    line-height: 157.5%;
    color: $text;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-height: 71px;
    overflow: hidden;
  }

  @include PC {
    padding: 19px 14px 16px 30px;
  }
}
</style>
